import { Fetch, AppConfig } from "../helpers";

export default class slotsApi {
  static getSlotsGames = (templateId) => {
    const response = Fetch.fetch({
      methodName: `GetSlotsGames?TemplateId=${templateId}`,
      method: "GET",
      url: AppConfig.api.slots,
    });
    return response;
  };
  static slotsConnect = (data) => {
    const response = Fetch.fetch({
      methodName: "SlotsConnect",
      method: "POST",
      url: AppConfig.api.slots,
      data,
    });
    return response;
  };

  static getJackpots = () => {
    const response = Fetch.fetch({
      methodName: "GetJackpots",
      method: "POST",
      url: AppConfig.api.slots,
    });
    return response;
  };
  static getSlotsBonusGamesByConditionId = (data) => {
    const response = Fetch.fetch({
      methodName: "GetSlotsBonusGamesByConditionId",
      method: "POST",
      url: AppConfig.api.members,
      data,
    });
    return response;
  };
}
